module.exports = __webpack_public_path__ + "img/osta.ad16c532.png";